import { registerPlugin } from "@capacitor/core";

export type OAuthSessionPlugin = {
  /**
   * Open `url` in an ASWebAuthenticationSession and resolve with the final
   * redirect URL once the OAuth flow redirects to `callbackScheme://...`.
   * Rejects with "cancelled" if the user dismisses the sheet.
   */
  start: (options: {
    url: string;
    callbackScheme: string;
  }) => Promise<{ url: string }>;
};

export const OAuthSession = registerPlugin<OAuthSessionPlugin>("OAuthSession");
